/** An switch 'flip' event that assists in unifying Mouse and Touch Events
    over Mobile and Desktop Platforms
*/
export default class Flip extends CustomEvent {
    constructor(caller) {
        super('flip', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
